module.exports = __webpack_public_path__ + "img/arrows-up.08ff8456.svg";